import React from 'react';
import { format } from 'date-fns';
import { User, Bot } from 'lucide-react';
import { ChatMessage as ChatMessageType } from '../../types';
import { classNames } from '../../utils/classNames';
import { useTheme } from '../../contexts/ThemeContext';

interface ChatMessageProps {
  message: ChatMessageType;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const { theme } = useTheme();
  const isUser = message.role === 'user';
  const isCanceled = message.isCanceled;
  const timestamp = message.timestamp ? new Date(message.timestamp) : new Date();

  return (
    <div className={classNames(
      'flex gap-3 mb-4',
      isUser ? 'justify-end' : 'justify-start'
    )}>
      {!isUser && (
        <div className="flex-shrink-0">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#2c3f50] to-[#0b1f35] flex items-center justify-center">
            <Bot className="w-5 h-5 text-white" />
          </div>
        </div>
      )}
      
      <div className={classNames(
        'max-w-3xl',
        isUser ? 'order-first' : ''
      )}>
        <div className={classNames(
          'rounded-xl px-4 py-3 chat-message',
          isUser ? 'user' : 'assistant',
          isCanceled ? 'canceled' : ''
        )}>
          <div className="prose prose-sm max-w-none">
            {/* Support markdown-style formatting */}
            <div 
              className="whitespace-pre-wrap"
              dangerouslySetInnerHTML={{
                __html: message.content
                  .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                  .replace(/\*(.*?)\*/g, '<em>$1</em>')
                  .replace(/`(.*?)`/g, `<code class="bg-opacity-30 px-1 py-0.5 rounded text-sm ${isUser ? 'bg-yellow-500 text-yellow-900' : 'bg-blue-500 text-white'}">$1</code>`)
              }}
            />
          </div>
        </div>
        
        <div className={classNames(
          'text-xs text-slate-400 mt-1',
          isUser ? 'text-right' : 'text-left'
        )}>
          {format(timestamp, 'h:mm a')}
        </div>
      </div>

      {isUser && (
        <div className="flex-shrink-0">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-black via-[#0b1f35] to-black flex items-center justify-center">
            <User className="w-5 h-5 text-white" />
          </div>
        </div>
      )}
    </div>
  );
};